//Sub permission: check \App\Lib\AdminPermissions.php
import routerConfigs from '../router-configs/ptRouterConfigs'

export default [
  {
    title: 'Paid Tester',
    icon: 'GiftIcon',
    children: [
      {
        url: routerConfigs.PT_ADJUST_EVENT_LOGS.path,
        title: 'Adjust Event Logs',
        icon: 'FileTextIcon',
        route: routerConfigs.PT_ADJUST_EVENT_LOGS.name,
        sub_permissions: [
          {
            id: routerConfigs.PT_ADJUST_EVENT_LOGS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.PT_AFFILIATE_PARTNERS.path,
        title: 'Affiliate Partners',
        icon: 'UserPlusIcon',
        route: routerConfigs.PT_AFFILIATE_PARTNERS.name,
        sub_permissions: [
          {
            id: routerConfigs.PT_AFFILIATE_PARTNERS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.PT_BONUS_CODES.path,
        title: 'Bonus Codes',
        icon: 'GiftIcon',
        route: routerConfigs.PT_BONUS_CODES.name,
        sub_permissions: [
          {
            id: routerConfigs.PT_BONUS_CODES.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.PT_BONUS_CODE_REDEMPTIONS.path,
        title: 'Bonus Code Redemptions',
        icon: 'DollarSignIcon',
        route: routerConfigs.PT_BONUS_CODE_REDEMPTIONS.name,
        sub_permissions: [
          {
            id: routerConfigs.PT_BONUS_CODE_REDEMPTIONS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.PT_LOG_SPEND.path,
        title: 'Log Spend',
        icon: 'DollarSignIcon',
        route: routerConfigs.PT_LOG_SPEND.name,
        sub_permissions: [
          {
            id: routerConfigs.PT_LOG_SPEND.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.PT_USERS.path,
        title: 'Users',
        icon: 'UsersIcon',
        route: routerConfigs.PT_USERS.name,
        sub_permissions: [
          {
            id: routerConfigs.PT_USERS.name,
            text: 'Main',
            main: true
          },
          {
            id: 'pt_users_export',
            text: 'PT Users Export',
            always_available_for_ids: [...window.CONST_TOP_ADMIN_IDS, 9]
          },
          {
            id: 'pt_users_delete',
            text: 'PT Users Delete',
            always_available_for_ids: window.CONST_TOP_ADMIN_IDS
          }
        ]
      },
      {
        url: routerConfigs.PT_USER_REWARD_ELIGIBILITY_LOGS.path,
        title: 'User Reward Eligibility Logs',
        icon: 'FileTextIcon',
        route: routerConfigs.PT_USER_REWARD_ELIGIBILITY_LOGS.name,
        sub_permissions: [
          {
            id: routerConfigs.PT_USER_REWARD_ELIGIBILITY_LOGS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        title: 'PT User details',
        hidden: true,
        sub_permissions: [
          {
            id: routerConfigs.PT_USER_DETAILS.name,
            text: 'Main',
            main: true
          },
          {
            id: 'pt_user_credit',
            text: 'PT User Credit',
            always_available_for_ids: [...window.CONST_TOP_ADMIN_IDS, 26, 32, 50, 93]
          },
          {
            id: 'pt_user_level',
            text: 'PT User Level'
          },
          {
            id: 'pt_overwrite_eligible',
            text: 'PT Overwrite Eligible',
            always_available_for_ids: window.CONST_TOP_ADMIN_IDS
          }
        ]
      },
      {
        url: routerConfigs.PT_TRANSACTIONS.path,
        title: 'Transactions',
        icon: 'DatabaseIcon',
        route: routerConfigs.PT_TRANSACTIONS.name,
        sub_permissions: [
          {
            id: routerConfigs.PT_TRANSACTIONS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.PT_CLAIMS.path,
        title: 'Claims',
        icon: 'CheckSquareIcon',
        route: routerConfigs.PT_CLAIMS.name,
        sub_permissions: [
          {
            id: routerConfigs.PT_CLAIMS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.PT_COHORT_ANALYSIS.path,
        title: 'Cohort Analysis',
        icon: 'LayoutIcon',
        route: routerConfigs.PT_COHORT_ANALYSIS.name,
        sub_permissions: [
          {
            id: routerConfigs.PT_COHORT_ANALYSIS.name,
            text: 'Main',
            main: true
          },
          {
            id: 'pt_cohort_analysis_export',
            text: 'PT Cohort Analysis Export',
            always_available_for_ids: [...window.CONST_TOP_ADMIN_IDS, 9]
          }
        ]
      },
      {
        url: routerConfigs.PT_LEADERBOARDS.path,
        title: 'Leaderboards',
        icon: 'BarChart2Icon',
        route: routerConfigs.PT_LEADERBOARDS.name,
        sub_permissions: [
          {
            id: routerConfigs.PT_LEADERBOARDS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.PT_LEVELS.path,
        title: 'Levels',
        icon: 'BarChartIcon',
        route: routerConfigs.PT_LEVELS.name,
        sub_permissions: [
          {
            id: routerConfigs.PT_LEVELS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.PT_SETTINGS.path,
        title: 'Settings',
        icon: 'SettingsIcon',
        route: routerConfigs.PT_SETTINGS.name,
        always_available_for_ids: [...window.CONST_TOP_ADMIN_IDS, 5, 6, 55],
        sub_permissions: [
          {
            id: routerConfigs.PT_SETTINGS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.PT_FRONTEND_SETTINGS.path,
        title: 'Frontend Settings',
        icon: 'SlidersIcon',
        route: routerConfigs.PT_FRONTEND_SETTINGS.name,
        always_available_for_ids: [...window.CONST_TOP_ADMIN_IDS, 5, 6, 55],
        sub_permissions: [
          {
            id: routerConfigs.PT_FRONTEND_SETTINGS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.PT_CAMPAIGN_SETTINGS.path,
        title: 'Campaign Settings',
        icon: 'TargetIcon',
        route: routerConfigs.PT_CAMPAIGN_SETTINGS.name,
        always_available_for_ids: [...window.CONST_TOP_ADMIN_IDS, 5, 6, 55],
        sub_permissions: [{ id: routerConfigs.PT_CAMPAIGN_SETTINGS.name, text: 'Main', main: true }]
      },
      {
        url: routerConfigs.PT_TUNE_REJECTION_SETTINGS.path,
        title: 'Tune Rejection Settings',
        icon: 'SettingsIcon',
        route: routerConfigs.PT_TUNE_REJECTION_SETTINGS.name,
        always_available_for_ids: [...window.CONST_TOP_ADMIN_IDS, 5, 6, 55],
        sub_permissions: [{ id: routerConfigs.PT_TUNE_REJECTION_SETTINGS.name, text: 'Main', main: true }]
      },
      {
        url: routerConfigs.PT_TUNE_REJECTIONS.path,
        title: 'Tune Rejections',
        icon: 'BarChart2Icon',
        route: routerConfigs.PT_TUNE_REJECTIONS.name,
        always_available_for_ids: [...window.CONST_TOP_ADMIN_IDS, 5, 6, 55],
        sub_permissions: [{ id: routerConfigs.PT_TUNE_REJECTIONS.name, text: 'Main', main: true }]
      },
      {
        url: routerConfigs.PT_TRIGGERS.path,
        title: 'Triggers',
        icon: 'DiscIcon',
        route: routerConfigs.PT_TRIGGERS.name,
        sub_permissions: [
          {
            id: routerConfigs.PT_TRIGGERS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.PT_PERFORMANCE.path,
        title: 'Performance',
        icon: 'PieChartIcon',
        route: routerConfigs.PT_PERFORMANCE.name,
        sub_permissions: [
          {
            id: routerConfigs.PT_PERFORMANCE.name,
            text: 'Main',
            main: true
          },
          {
            id: routerConfigs.PT_PERFORMANCE_EXPORT.name,
            text: 'PT Performance Export',
            always_available_for_ids: [...window.CONST_TOP_ADMIN_IDS, 9]
          }
        ]
      },
      {
        url: routerConfigs.PT_REWARDS.path,
        title: 'Rewards',
        icon: 'AwardIcon',
        route: routerConfigs.PT_REWARDS.name,
        sub_permissions: [
          {
            id: routerConfigs.PT_REWARDS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.PT_EMAILS.path,
        title: 'E-Mails',
        icon: 'MailIcon',
        route: routerConfigs.PT_EMAILS.name,
        sub_permissions: [
          {
            id: routerConfigs.PT_EMAILS.name,
            text: 'Main',
            main: true
          },
          {
            id: 'pt_emails_view_url',
            text: 'PT Emails View URL',
            always_available_for_ids: window.CONST_TOP_ADMIN_IDS
          }
        ]
      },
      {
        url: routerConfigs.PT_OFFER_WALL_PERFORMANCE.path,
        title: 'Offerwall Performance',
        icon: 'CpuIcon',
        route: routerConfigs.PT_OFFER_WALL_PERFORMANCE.name,
        sub_permissions: [
          {
            id: routerConfigs.PT_OFFER_WALL_PERFORMANCE.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.PT_ADJUST_CONFIG.path,
        title: 'Adjust Config',
        icon: 'CodesandboxIcon',
        route: routerConfigs.PT_ADJUST_CONFIG.name,
        sub_permissions: [
          {
            id: routerConfigs.PT_ADJUST_CONFIG.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.PT_DYNAMIC_CAMPAIGNS.path,
        title: 'Dynamic Campaigns',
        icon: 'MailIcon',
        route: routerConfigs.PT_DYNAMIC_CAMPAIGNS.name,
        sub_permissions: [
          {
            id: routerConfigs.PT_DYNAMIC_CAMPAIGNS.name,
            text: 'Main',
            main: true
          },
          {
            id: routerConfigs.PT_DYNAMIC_CAMPAIGNS_EMAILS.name,
            text: 'Email Campaigns'
          },
          {
            id: routerConfigs.PT_DYNAMIC_CAMPAIGNS_EMAILS_CREATE.name,
            text: 'Campaign Emails Create'
          },
          {
            id: routerConfigs.PT_DYNAMIC_CAMPAIGNS_EMAILS_EDIT.name,
            text: 'Campaign Emails Edit'
          },
          {
            id: routerConfigs.PT_DYNAMIC_CAMPAIGNS_EMAILS_TRANSLATIONS_EDIT.name,
            text: 'Campaign Emails Translation Edit'
          },
          {
            id: routerConfigs.PT_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS.name,
            text: 'Push Notifications Campaigns'
          },
          {
            id: routerConfigs.PT_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_CREATE.name,
            text: 'Campaign Push Notifications Create'
          },
          {
            id: routerConfigs.PT_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_EDIT.name,
            text: 'Campaign Push Notifications Edit'
          },
          {
            id: routerConfigs.PT_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_TRANSLATIONS_EDIT.name,
            text: 'Campaign Push Notifications Translation Edit'
          }
        ]
      }
    ]
  }
]
